export default "__VITE_ASSET__hZFgUfHd__"